// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yP8W","col":"styles_col__35N5l"};